export default "__VITE_ASSET__xBhcLj0e__"